// Theme color definitions for UI customization
// Each theme provides the full color scheme used throughout the app

export const THEME_COLORS = {
  blue: {
    gradient: 'from-blue-600 to-indigo-600',
    headerBg: 'bg-gradient-to-r from-blue-600 to-indigo-600',
    chatAccent: 'bg-blue-600',
    chatAccentLight: 'text-blue-100',
    sidebarBg: 'bg-gradient-to-b from-blue-600 via-blue-700 to-indigo-800',
    navItem: 'text-white/70 hover:text-white hover:bg-white/10',
    navActive: 'bg-white/20 text-white font-semibold border-l-4 border-white shadow-lg shadow-black/10',
    navActiveIcon: 'text-white',
    infoCardBg: 'bg-white/15 border-white/20',
    infoCardText: 'text-white/90',
    infoCardLabel: 'text-white/70',
    infoCardIcon: 'text-white/80',
  },
  teal: {
    gradient: 'from-emerald-600 to-teal-600',
    headerBg: 'bg-gradient-to-r from-emerald-600 to-teal-600',
    chatAccent: 'bg-emerald-600',
    chatAccentLight: 'text-emerald-100',
    sidebarBg: 'bg-gradient-to-b from-emerald-600 via-emerald-700 to-teal-800',
    navItem: 'text-white/70 hover:text-white hover:bg-white/10',
    navActive: 'bg-white/20 text-white font-semibold border-l-4 border-white shadow-lg shadow-black/10',
    navActiveIcon: 'text-white',
    infoCardBg: 'bg-white/15 border-white/20',
    infoCardText: 'text-white/90',
    infoCardLabel: 'text-white/70',
    infoCardIcon: 'text-white/80',
  },
  violet: {
    gradient: 'from-indigo-600 to-violet-600',
    headerBg: 'bg-gradient-to-r from-indigo-600 to-violet-600',
    chatAccent: 'bg-indigo-600',
    chatAccentLight: 'text-indigo-100',
    sidebarBg: 'bg-gradient-to-b from-indigo-600 via-indigo-700 to-violet-800',
    navItem: 'text-white/70 hover:text-white hover:bg-white/10',
    navActive: 'bg-white/20 text-white font-semibold border-l-4 border-white shadow-lg shadow-black/10',
    navActiveIcon: 'text-white',
    infoCardBg: 'bg-white/15 border-white/20',
    infoCardText: 'text-white/90',
    infoCardLabel: 'text-white/70',
    infoCardIcon: 'text-white/80',
  },
  orange: {
    gradient: 'from-orange-500 to-amber-600',
    headerBg: 'bg-gradient-to-r from-orange-500 to-amber-600',
    chatAccent: 'bg-orange-500',
    chatAccentLight: 'text-orange-100',
    sidebarBg: 'bg-gradient-to-b from-orange-500 via-orange-600 to-amber-700',
    navItem: 'text-white/70 hover:text-white hover:bg-white/10',
    navActive: 'bg-white/20 text-white font-semibold border-l-4 border-white shadow-lg shadow-black/10',
    navActiveIcon: 'text-white',
    infoCardBg: 'bg-white/15 border-white/20',
    infoCardText: 'text-white/90',
    infoCardLabel: 'text-white/70',
    infoCardIcon: 'text-white/80',
  },
  rose: {
    gradient: 'from-rose-500 to-pink-600',
    headerBg: 'bg-gradient-to-r from-rose-500 to-pink-600',
    chatAccent: 'bg-rose-500',
    chatAccentLight: 'text-rose-100',
    sidebarBg: 'bg-gradient-to-b from-rose-500 via-rose-600 to-pink-700',
    navItem: 'text-white/70 hover:text-white hover:bg-white/10',
    navActive: 'bg-white/20 text-white font-semibold border-l-4 border-white shadow-lg shadow-black/10',
    navActiveIcon: 'text-white',
    infoCardBg: 'bg-white/15 border-white/20',
    infoCardText: 'text-white/90',
    infoCardLabel: 'text-white/70',
    infoCardIcon: 'text-white/80',
  },
  crimson: {
    gradient: 'from-crimson-600 to-crimson-800',
    headerBg: 'bg-gradient-to-r from-crimson-600 to-crimson-800',
    chatAccent: 'bg-crimson-600',
    chatAccentLight: 'text-crimson-100',
    sidebarBg: 'bg-gradient-to-b from-crimson-600 via-crimson-700 to-crimson-800',
    navItem: 'text-white/70 hover:text-white hover:bg-white/10',
    navActive: 'bg-white/20 text-white font-semibold border-l-4 border-white shadow-lg shadow-black/10',
    navActiveIcon: 'text-white',
    infoCardBg: 'bg-white/15 border-white/20',
    infoCardText: 'text-white/90',
    infoCardLabel: 'text-white/70',
    infoCardIcon: 'text-white/80',
  },
};

// Theme options for the selector UI
export const THEME_OPTIONS = [
  { id: 'blue', label: 'Niebieski', color: '#2563eb' },
  { id: 'teal', label: 'Szmaragdowy', color: '#059669' },
  { id: 'violet', label: 'Fioletowy', color: '#7c3aed' },
  { id: 'orange', label: 'Pomaraczowy', color: '#f97316' },
  { id: 'rose', label: 'Rowy', color: '#f43f5e' },
  { id: 'crimson', label: 'Karmazynowy', color: '#DC143C' },
];

// Get the hex color for a theme (used for PWA theme-color meta tag)
export const getThemeHexColor = (themeId) => {
  const theme = THEME_OPTIONS.find(t => t.id === themeId);
  return theme?.color || '#2563eb';
};

// Default theme per role (when user hasn't selected a preference)
export const DEFAULT_THEME_BY_ROLE = {
  parent: 'blue',
  teacher: 'teal',
  branch_admin: 'violet',
  super_admin: 'crimson',
};
